import { Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useEffectOnce } from 'hook/useEffectOnce'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ItemsList } from 'page/catalog/Content/ItemsList'
import { BasicFilters } from 'page/catalog/DemoCatalogFilters/BasicFilters'
import { StandFilters } from 'page/catalog/DemoCatalogFilters/StandFilters'
import { MoreBottom } from 'page/catalog/Pagination/MoreBottom'
import { StandPagination } from 'page/catalog/Pagination/StandPagination'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { useState } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import css from './StandContent.module.scss'

export const StandContent = observer(() => {
  const { small } = ui.window
  const demo = useDemo()
  const { basic, items } = demo
  const empty = !items.length
  const { busy, reloading, error, search } = demo.form
  const height = small ? 400 : 800
  const [lock, setLock] = useState(false)

  useEffectOnce(() => {
    const id = setInterval(() => {
      const max = !!document.querySelector('.showoff-widget-max')
      setLock(max)
    }, 100)
    return () => clearInterval(id)
  })

  useBodyScrollLock(lock)

  return <>
    <Vertical className={css.content}>
      <Vertical gap={16}>
        {!basic && <StandPagination />}
        {basic ? <BasicFilters /> : <StandFilters />}
      </Vertical>
      <Space gap={20} top>
        {empty && <Space height={height} wide center>
          {!busy && <Typo size={14} secondary error={error}>
            {error ? i18n('Error') : search ? i18n('demo.NotingFound') : i18n('demo.NoItems')}
          </Typo>}
        </Space>}
        {!empty && <ItemsList />}
        {reloading && <Space height={height} pin={[0, 0, null, 0]} center>
          <Spinner />
        </Space>}
      </Space>
      <MoreBottom />
    </Vertical>
  </>
})
